// ABOUTME: Uses Better Auth's browser client for social sign-in and OAuth continuation.
// ABOUTME: The provider plugin forwards only the signed authorization query parameters.
import { createAuthClient } from "better-auth/react";
import { oauthProviderClient } from "@better-auth/oauth-provider/client";

export const authClient = createAuthClient({
  plugins: [oauthProviderClient()],
});
